import { SxProps, Theme } from '@mui/system';

const styles = {
  root: {
    background: 'white',
    padding: '32px',
    borderRadius: '4px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    maxWidth: '143px',
    minWidth: '143px',
    backgroundColor: 'primary.main',
  },
  logoText: {
    fontFamily: '"Redressed", serif',
    fontWeight: 400,
    color: 'white',
    fontSize: 48,
    textAlign: 'center',
  },
  dateBox: {
    padding: '9px 16px 9px 16px',
    border: '1px solid',
    borderColor: 'common.grey350',
  },
  title: {
    color: 'grey.500',
    fontSize: 16,
    fontWeight: 600,
    paddingBottom: '12px',
  },
  infoText: {
    color: 'grey.800',
    fontSize: 16,
    fontWeight: 600,
  },
  invoiceTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: 'common.grey850',
  },
  invoiceContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  pdfContainer: {
    position: 'absolute',
    right: 0,
  },
  titleContainer: {
    display: 'flex',
    mb: '40px',
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  flex: {
    display: 'flex',
  },
  margin: {
    marginRight: '24px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
